// Global Instructions Rule Applied!

export const SET_TOPICS = 'distribution_lists/SET_TOPICS' as const
export const SET_ACTIVE_FILTERS = 'distribution_lists/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'distribution_lists/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'distribution_lists/CLEAR_ACTIVE_FILTERS' as const
export const ADD_TOPIC = 'distribution_lists/ADD_TOPIC' as const
export const UPDATE_TOPIC_RECORD = 'distribution_lists/UPDATE_TOPIC_RECORD' as const
export const REMOVE_TOPIC = 'distribution_lists/REMOVE_TOPIC' as const
